import React, { useCallback, useEffect, useRef, useState } from 'react';
import Input from '@app/react-common/components/input/Input';
import { useClickedOutside } from '@app/react-common/hooks/useClickOutside';

const COMBINED_NAME_PLACEHOLDER = 'Standard shipping';

interface CombinedNameBannerProps {
  value: string;
  onChange: (name: string) => void;
}

export const CombinedNameBanner = ({ value, onChange }: CombinedNameBannerProps) => {
  const [editing, setEditing] = useState(false);
  const [combinedName, setCombinedName] = useState(value ?? '');
  const draftRef = useRef(value ?? '');
  const fieldRef = useRef<HTMLDivElement>(null);

  const updateDraft = (next: string) => {
    draftRef.current = next;
    setCombinedName(next);
  };

  const startEditing = () => {
    updateDraft(value ?? '');
    setEditing(true);
  };

  // Persist only when clicking outside the field while editing.
  const handleClickedOutside = useCallback(() => {
    if (!editing) {
      return;
    }
    onChange(draftRef.current);
    setEditing(false);
  }, [editing, onChange]);

  useClickedOutside(fieldRef, handleClickedOutside);

  useEffect(() => {
    if (editing) {
      fieldRef.current?.querySelector('input')?.focus();
    }
  }, [editing]);

  return (
    <div className="delivery-methods-list__group-by__combined-name">
      <span className="delivery-methods-list__group-by__combined-name__label">Combined shipping method name:</span>
      {editing ? (
        <div ref={fieldRef} className="delivery-methods-list__group-by__combined-name__field">
          <Input
            type="text"
            value={combinedName}
            onChange={(e) => updateDraft(e.target.value)}
            placeholder={COMBINED_NAME_PLACEHOLDER}
          />
        </div>
      ) : (
        <button type="button" className="delivery-methods-list__group-by__combined-name__value" onClick={startEditing}>
          <span>{value || COMBINED_NAME_PLACEHOLDER}</span>
          <i className="icon icon-oeag" />
        </button>
      )}
      <span className="delivery-methods-list__group-by__combined-name__hint">
        Shown when cart spans multiple groups
      </span>
    </div>
  );
};
